import * as React from "react";
import { ProgrammeSession } from "./Programme";
import SessionCard from "./Session/SessionCard";

interface HallSessionsProps {
    hallName: string;
    programmes: Array<ProgrammeSession>;
    activeHall: ProgrammeSession["hall"];
    getTabColor: any;
}

const HallSessions: React.FC<HallSessionsProps> = ({ hallName, programmes, activeHall, getTabColor }) => {
    const active = activeHall === hallName;

    const pastSessions = programmes?.filter((s) => s.durationInSeconds + s.secondsTillStart < 0);
    const upcomingSessions = programmes?.filter((s) => s.durationInSeconds + s.secondsTillStart >= 0);

    // const hallLabel = hallName === "Hall E" ? "CCNDP Interactive Workshop" : hallName;

    const hallLabel = () => {
        switch (hallName) {
            case "Pre-Congress":
                return "Hospital Sultan Abdul Aziz Shah, UPM";
            case "Hall E":
                return "CCNDP Interactive Workshop";
            default:
                return hallName;
        }
    };

    return (
        <div className={`hallContainer ${active && "d-block"} d-md-block`}>
            <div className="d-flex d-none d-md-block">
                <div className="hallTabs text-center fw-bold" style={{ background: getTabColor(hallName) }}>
                    {hallLabel()}
                </div>
            </div>
            <div className={`sessionContainer p-0 p-md-3`}>
                {programmes?.map((session) => (
                    <SessionCard key={session.id} {...session} />
                ))}
            </div>
        </div>
    );
};

export default HallSessions;
